var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _vm.notEditing
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-10" }, [
            _c("h3", [_vm._v(_vm._s(_vm.endorsement.company_name))]),
            _vm._v(" "),
            _c("p", [
              _c("i", { staticClass: "fa fa-calendar fa-fw" }),
              _vm._v(" Submitted: " + _vm._s(_vm.endorsementDateEndorsed)),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.endorsement.description))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-6 col-md-2 text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-info",
                on: { click: _vm.handleEditCallback },
              },
              [
                _c("i", { staticClass: "fa fa-pencil" }),
                _vm._v(" Edit\n      "),
              ]
            ),
          ]),
        ])
      : _c("div", { staticClass: "form-horizontal" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-12" }, [
              _c(
                "div",
                {
                  class: _vm.$hasErrorClass(_vm.$v.company_name, "form-group"),
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "control-label col-xs-12 col-sm-4 col-md-3",
                    },
                    [
                      _vm._v(
                        _vm._s(_vm._f("sentenceCase")(_vm.$t("organisation"))) +
                          " / Client Name"
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-8 col-md-9" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.company_name.$model,
                            expression: "$v.company_name.$model",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "company_name", type: "text" },
                        domProps: { value: _vm.$v.company_name.$model },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.company_name,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("vuelidate-help", {
                        attrs: {
                          label: "Company name",
                          field: _vm.$v.company_name,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: _vm.$hasErrorClass(_vm.$v.date_endorsed, "form-group"),
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "control-label col-xs-12 col-sm-4 col-md-3",
                    },
                    [_vm._v("Endorsement Date")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-8 col-md-9" },
                    [
                      _c("flat-pickr", {
                        staticClass: "form-control",
                        attrs: {
                          config: _vm.flatPickrConfig,
                          placeholder: "DD/MM/YYYY",
                          name: "date_endorsed",
                        },
                        model: {
                          value: _vm.$v.date_endorsed.$model,
                          callback: function ($$v) {
                            _vm.$set(_vm.$v.date_endorsed, "$model", $$v)
                          },
                          expression: "$v.date_endorsed.$model",
                        },
                      }),
                      _vm._v(" "),
                      _c("vuelidate-help", {
                        attrs: {
                          label: "Endorsement date",
                          field: _vm.$v.date_endorsed,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { class: _vm.$hasErrorClass(_vm.$v.description, "form-group") },
                [
                  _c(
                    "label",
                    {
                      staticClass: "control-label col-xs-12 col-sm-4 col-md-3",
                    },
                    [_vm._v("Description")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-8 col-md-9" },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.description.$model,
                            expression: "$v.description.$model",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { name: "description", rows: "8" },
                        domProps: { value: _vm.$v.description.$model },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.description,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("vuelidate-help", {
                        attrs: {
                          label: "Description",
                          field: _vm.$v.description,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6 col-md-2 col-md-offset-8" },
              [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-sm btn-success btn-block",
                    attrs: { click: _vm.handleSaveCallback },
                  },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(" Save\n        "),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6 col-md-2" },
              [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-sm btn-danger btn-block",
                    attrs: { click: _vm.handleDeleteCallback },
                  },
                  [
                    _c("i", { staticClass: "fa fa-times" }),
                    _vm._v(" Delete\n        "),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }